import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { handleRedirect } from '../../utils/deviceDetection';
import './KycLoading.css';

const KycLoading = () => {
  const location = useLocation();
  const [showCountdown, setShowCountdown] = useState(false);
  const [countdown, setCountdown] = useState(3);

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    setTimeout(() => {

      setShowCountdown(true);

      let countdownValue = 2;
      const timer = setInterval(() => {
        setCountdown(countdownValue);
        countdownValue--;
        if (countdownValue < 0) {
          clearInterval(timer);
          handleRedirect(urlParams, '/kyc-result');
        }
      }, 1000);
    }, 1000);
  }, []);

  return (
    <div className="kyc-loading-container">
      <div className="kyc-container">
        <div className="logo-container">
          <div className="fws-logo">
            <img src="/assets/images/newlogo.png" alt="FWS Logo" />
          </div>
          <div className="arrow-animation">
            <span className="arrow-text">&gt;&gt;&gt;</span>
          </div>
          <div className="kyc-logo">
          <img src="/assets/images/KYCVerficationIcon.svg"  />
          </div>
        </div>

        <h1>KYC Verification</h1>
        <p className="subtitle">Preparing your KYC verification... this will just take a moment.</p>

        {showCountdown && (
          <div className="countdown-text">
            Redirecting in <span className="countdown-number">{countdown}</span> Seconds...
          </div>
        )}


        <div className="info-section">
          <h4>What's Happening?</h4>
          <ul>
            <li>Connecting to the KYC service</li>
            <li>Validating your identity details</li>
            <li>Securing your information</li>
            <li>Redirecting you to the verification page</li>
          </ul>
        </div>

        <div className="divider"></div>

        <div className="security-section">
          <div className="security-icon">
            <img src="/assets/images/SecureProcessIcon.svg" alt="Secure Process" />
          </div>
          <p className="security-text">
            <strong>Secure Process:</strong> Your data is encrypted and only used for identity verification
          </p>
        </div>
      </div>
    </div>
  );
};

export default KycLoading;
